import React from 'react';
import { descriptionToSegments } from '../utils/eventDescription';

function renderSegments(segments) {
  return segments.map((seg, index) => {
    if (seg.type === 'link') {
      return (
        <a
          key={index}
          href={seg.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {seg.value}
        </a>
      );
    }
    return <React.Fragment key={index}>{seg.value}</React.Fragment>;
  });
}

export function EventDescriptionText({
  text,
  emptyLabel = 'No description available.',
}) {
  if (!text) {
    return <p className="event-detail-card__text">{emptyLabel}</p>;
  }

  const lines = text.split('\n');
  return (
    <div className="event-detail-card__text">
      {lines.map((line, index) => {
        const content = renderSegments(descriptionToSegments(line));
        if (line.startsWith('• ')) {
          return (
            <p key={index} className="event-detail-card__bullet">
              {content}
            </p>
          );
        }
        return (
          <p
            key={index}
            className={
              line
                ? 'event-detail-card__line'
                : 'event-detail-card__line event-detail-card__line--blank'
            }
          >
            {content}
          </p>
        );
      })}
    </div>
  );
}
